import Pagination from "../../Monitor/components/Pagination";
import AuditPerformRow from "./AuditPerformRow";

const AuditPerformsTable = ({
  performs,
  appNameById,
  subjectColumns = [],
  pageTrack,
  pagination,
  onPageChange,
  onLimitChange,
  onOpen
}) => {
  const colCount = 9 + subjectColumns.length;
  return (
    <div className="monitor_container">
      <div className="table-wrapper">
        <table className="log-table">
          <thead>
            <tr>
              <th>Started</th>
              <th>Application</th>
              <th>Workflow</th>
              <th>Activity</th>
              {subjectColumns.map((c) => (
                <th key={c.idx}>{c.label}</th>
              ))}
              <th>User</th>
              <th>Status</th>
              <th>Duration</th>
              <th>Events</th>
              <th>Error</th>
            </tr>
          </thead>
          <tbody>
            {performs.length === 0 ? (
              <tr>
                <td colSpan={colCount} style={{ textAlign: "center", padding: "16px", color: "#6b7280" }}>
                  No performs found.
                </td>
              </tr>
            ) : (
              performs.map((perform, index) => (
                <AuditPerformRow
                  key={`${perform?.trace_id}-${index}`}
                  perform={perform}
                  appName={appNameById?.[perform?.app_id]}
                  subjectColumns={subjectColumns}
                  onOpen={onOpen}
                />
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="pt_4">
        <Pagination
          pageTrack={pageTrack}
          pagination={pagination}
          onPageChange={onPageChange}
          onLimitChange={onLimitChange}
        />
      </div>
    </div>
  );
};

export default AuditPerformsTable;
